import React from 'react';
import { grayDarkM } from 'web-ui-kit/colors';

function ReferAFriendIcon(_ref) {
  var _ref$ariaLabel = _ref.ariaLabel,
      ariaLabel = _ref$ariaLabel === void 0 ? 'refer a friend' : _ref$ariaLabel,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? grayDarkM : _ref$color,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? '19' : _ref$size;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      "aria-label": ariaLabel,
      className: className,
      width: size,
      height: size,
      viewBox: "0 0 19 19",
      onClick: onClick,
      role: "img",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M11.2298 0.625C10.2727 0.625 9.42289 1.11126 8.91729 1.85C8.44225 1.34679 7.77135 1.025 7.02979 1.025C5.60094 1.025 4.42979 2.19617 4.42979 3.625C4.42979 4.13973 4.58101 4.61985 4.84229 5.025L0.629785 5.025C0.315625 5.02503 0.0298252 5.31085 0.0297852 5.625L0.0297852 9.225C0.0298252 9.53914 0.315625 9.82496 0.629785 9.825L1.22979 9.825L1.22979 18.025C1.22983 18.3391 1.51563 18.625 1.82979 18.625L16.2298 18.625C16.5439 18.625 16.8297 18.3391 16.8298 18.025L16.8298 9.825L17.4298 9.825C17.7439 9.82496 18.0297 9.53914 18.0298 9.225L18.0298 5.625C18.0297 5.31085 17.7439 5.02503 17.4298 5.025L13.5235 5.025C13.8417 4.57079 14.0298 4.01812 14.0298 3.425C14.0298 1.88571 12.7691 0.625 11.2298 0.625ZM11.2298 1.825C12.1205 1.825 12.8298 2.53425 12.8298 3.425C12.8298 4.31575 12.1205 5.025 11.2298 5.025L9.62979 5.025C9.62979 4.49167 9.62979 3.95833 9.62979 3.425C9.62979 2.53425 10.339 1.825 11.2298 1.825ZM7.02979 2.225C7.81007 2.225 8.42979 2.84471 8.42979 3.625L8.42979 5.025L7.02979 5.025C6.24951 5.025 5.62979 4.40529 5.62979 3.625C5.62979 2.84471 6.24951 2.225 7.02979 2.225ZM1.22979 6.225C3.62979 6.225 6.02979 6.225 8.42979 6.225L8.42979 8.625C6.02979 8.625 3.62979 8.625 1.22979 8.625L1.22979 6.225ZM9.62979 6.225C12.0298 6.225 14.4298 6.225 16.8298 6.225L16.8298 8.625C14.4298 8.625 12.0298 8.625 9.62979 8.625L9.62979 6.225ZM2.42979 9.825L8.42979 9.825L8.42979 17.425L2.42979 17.425L2.42979 9.825ZM9.62979 9.825L15.6298 9.825L15.6298 17.425L9.62979 17.425L9.62979 9.825Z",
      fill: color
    }))
  );
}

export default ReferAFriendIcon;